/**
 * @fileoverview Derive spreadsheet presentation from authoritative receipt amounts. Person focus, month collapse and pagination never recalculate allocations or their denominators. Totals use reported cents, distinguish unresolved credit from zero, and include the complete matching scope rather than one page. Reconciliation always includes every contributor, including people outside the displayed personal period. This module owns no persistence or financial commands.
 */
export const hasContribution = cell => !!cell && (cell.hours == null || cell.allocation == null || Number(cell.hours) !== 0 || Number(cell.allocation) !== 0 || Object.keys(cell.edits || {}).length > 0);

const cents = value => {
    const text = String(value), negative = text.startsWith('-');
    const [whole, fraction = ''] = text.replace(/^[+-]/, '').split('.');
    return (BigInt(whole || '0') * 100n + BigInt((fraction + '00').slice(0, 2))) * (negative ? -1n : 1n);
};
const decimal = value => `${value < 0n ? '-' : ''}${(value < 0n ? -value : value) / 100n}.${String((value < 0n ? -value : value) % 100n).padStart(2, '0')}`;
export function ledgerTotal(rows, value) {
    let total = 0n, unresolved = 0;
    rows.forEach(row => { const amount = value(row); if (amount == null) unresolved += 1; else total += cents(amount); });
    return { amount: decimal(total), unresolved };
}
export const deductions = row => decimal(cents(row.values.expenses) + cents(row.values.local_counsel));
export function allocationDifference(row) {
    if (row.issues.length || Object.values(row.people).some(cell => cell.allocation == null)) return null;
    return decimal(cents(row.net) - Object.values(row.people).reduce((total, cell) => total + cents(cell.allocation), 0n));
}
